export const totalListItemSx = (theme) => ({
  backgroundColor: theme.palette.background.secondary,
  borderRadius: '5px',
  padding: '4px',
  marginBottom: '4px',
  maxWidth: '345px',
});

export const totalListItemIconSx = (theme) => ({
  color: theme.palette.tertiary.main,
  margin: '12px',
  minWidth: '0',
});

export const totalListItemTextSx = {
  flexDirection: 'column',
};

export const totalActivityTextSx = { fontSize: '12px', fontWeight: 500 };

export const totalDistanceTextSx = (theme) => ({
  color: theme.palette.quaternary.main,
  textShadow: 'grey 0px 0px 0.5px',
  fontSize: '20px',
  fontWeight: 500,
  lineHeight: 1,
});

export const totalCaloriesSx = {
  alignSelf: 'flex-end',
  justifyContent: 'flex-end',
  display: 'flex',
  flexGrow: 1,
  margin: '0px 4px 4px 0px',
};

export const totalCaloriesTextSx = {
  color: '#71767b',
  fontSize: '12px',
  fontWeight: 500,
  alignSelf: 'flex-end',
};
